module.exports = __webpack_public_path__ + "img/TECNOLOGIA-XL7-4.bb6a3ead.jpg";